
import { useNavigate } from "react-router-dom";  


export default function CuisinePage() {


const navigate = useNavigate()

  return (
    <div className="min-h-screen bg-white flex flex-col md:flex-row font-saol border-t border-black">
      {/* Left Text */}
      <div className="w-full md:w-1/3 flex items-center justify-center p-10">
        <h1 className="text-black text-4xl md:text-7xl leading-tight whitespace-pre-line">
          {`A\nBenchmark\nof\nPremium\nCuisine`}
        </h1>
      </div>

      {/* Center Circle Button */}
      <div  onClick={()=>navigate('/date')} className="w-full md:w-1/3 flex items-center cursor-pointer justify-center p-6">
        <div className="w-48 h-48 rounded-full bg-black flex items-center justify-center text-white text-center text-sm md:text-base leading-tight">
          <span className="font-semibold">TASTE NAMMOS<br />DUBAI</span>
        </div>
      </div>

      {/* Right Image */}
      <div className="w-full md:w-1/3 h-[60vh] md:h-auto">
        <img
          src="/2.webp"
          alt="Cuisine Visual"
          className="w-full h-full object-cover"
        />
      </div>
    </div>
  );
}
